import BasicFieldTokenizer from './BasicFieldTokenizer.js';
import ComparatorFieldTokenizer from './ComparatorFieldTokenizer.js';
import ConstantBooleanFieldTokenizer from './ConstantBooleanFieldTokenizer.js';
import ConstantNullFieldTokenizer from './ConstantNullFieldTokenizer.js';
import ConstantNumberFieldTokenizer from './ConstantNumberFieldTokenizer.js';
import ConstantStringFieldTokenizer from './ConstantStringFieldTokenizer.js';
import FunctionFieldTokenizer from './FunctionFieldTokenizer.js';
import InvalidFieldTokenizer from './InvalidFieldTokenizer.js';
import ListFieldTokenizer from './ListFieldTokenizer.js';
import LogicalFieldTokenizer from './LogicalFieldTokenizer.js';
import MathFieldTokenizer from './MathFieldTokenizer.js';
import RootFieldTokenizer from './RootFieldTokenizer.js';
export default {
  install(plugins) {
    plugins.addPlugin('Expression.Tokenizer', BasicFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', ComparatorFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', RootFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', ConstantBooleanFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', ConstantNullFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', ConstantNumberFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', ConstantStringFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', FunctionFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', InvalidFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', LogicalFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', MathFieldTokenizer);
    plugins.addPlugin('Expression.Tokenizer', ListFieldTokenizer);
  }
};